import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AuditLogPage } from '@/pages/audit/audit-log-page';

const SearchSchema = z.object({
  tab: z.enum(['actions', 'impersonations']).optional().catch(undefined),
  kind: z.string().max(100).optional().catch(undefined),
  target: z.string().max(50).optional().catch(undefined),
  targetId: z.string().uuid().optional().catch(undefined),
  actor: z.string().uuid().optional().catch(undefined),
  reads: z.enum(['show']).optional().catch(undefined),
  days: z.enum(['1', '7', '30', '90']).optional().catch(undefined),
  offset: z.coerce.number().int().min(0).optional().catch(undefined),
});
export type AuditSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute('/audit')({
  component: AuditLogPage,
  validateSearch: (s) => SearchSchema.parse(s),
});
